// The causes behind one currency's gap, in the order they are shown. Each one
// maps to a record list the API can return (see ITEM_KINDS). `amount` is the
// figure shown next to the count; `count` is how many records it stands for.
export const causesFor = (row) => {
  const u = row.unmirrored;
  const drift = u.conversionDrift ?? { count: 0, amount: 0, shortCount: 0, shortAmount: 0 };
  return [
    {
      kind: "conversions_unmirrored",
      group: "Movements that never reached the house merchant",
      label: "Conversions not mirrored since 4 Oct",
      count: u.conversionCount,
      amount: u.conversionNet,
      note: "Net effect on the consumer side. The house merchant did not make the other side.",
    },
    {
      kind: "septly_credited",
      group: "Movements that never reached the house merchant",
      label: "Septly deposits credited, no house-merchant row",
      count: u.septlyDepositsCredited.count,
      amount: u.septlyDepositsCredited.amount,
    },
    {
      kind: "septly_held",
      group: "Movements that never reached the house merchant",
      label: "Septly deposits held, no house-merchant row",
      count: u.septlyDepositsHeld.count,
      amount: u.septlyDepositsHeld.amount,
      note: "No effect on the gap: the consumer is not credited either. They are invisible on the merchant page.",
    },
    {
      kind: "one_sided_payouts",
      group: "Movements that never reached the house merchant",
      label: "Withdrawals debited from the consumer, never sent",
      count: u.oneSidedPayouts.count,
      amount: u.oneSidedPayouts.amount,
    },
    {
      kind: "declined_after_dispatch",
      group: "Movements that never reached the house merchant",
      label: "Payouts declined and refunded after sending",
      count: u.declinedAfterDispatch.count,
      amount: u.declinedAfterDispatch.amount,
    },
    {
      kind: "payout_fee_difference",
      group: "Differences that are expected",
      label: "Payout fee differences",
      count: u.payoutFeeDifference?.count ?? 0,
      amount: u.payoutFeeDifference?.amount ?? 0,
      note: "Consumer fees minus house-merchant fees. Payouts from the fee floor on no longer add to it.",
    },
    {
      kind: "conversion_drift_short",
      group: "Differences that are expected",
      label: "Mirrored conversion drift",
      count: drift.shortCount,
      amount: drift.amount,
      summary: drift.count > 0 ? `${drift.count} mirrored, ${drift.shortCount} where the house merchant got less` : null,
      note: "House merchant credit minus what the consumer received. Positive means the spread was kept. Records listed are the ones where it got less.",
    },
    {
      kind: "pre_mirror_conversions",
      group: "Known history and Novacrust-funded",
      label: "Conversions before 4 Oct (never mirrored)",
      count: row.leftovers?.preMirrorConversions?.count ?? 0,
      amount: row.leftovers?.preMirrorConversions?.net ?? 0,
      allTime: true,
      note: "Made before the house-merchant mirror existed. History, not a new miss.",
    },
    {
      kind: "campaign_rewards",
      group: "Known history and Novacrust-funded",
      label: "Rewards Novacrust funded",
      count: row.leftovers?.campaignRewards?.count ?? 0,
      amount: row.leftovers?.campaignRewards?.amount ?? 0,
      allTime: true,
      note: "Credited to consumers from Novacrust's own pocket. Expected.",
    },
  ];
};
